module.exports = __webpack_public_path__ + "media/assets/icons/chevron-small-right-b16bc30af964a1565e8ae2af0077b937.svg";